import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// angular materials
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';

// external plugins
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxPermissionsGuard } from 'ngx-permissions';

// ngrx
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgxPaginationModule } from 'ngx-pagination';
import { effects, ordersReducers } from 'src/app/store';

// combined common modules into one file
import * as fromGuards from 'src/app/store/guards';
import { SharedModule } from '../shared/shared.module';

// components & containers
import * as fromComponents from './components';

const orderRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./containers/orders-shell/orders-shell.component').then(
        (m) => m.OrdersShellComponent,
      ),
    canActivate: [
      fromGuards.DynamicAuthGuard,
      fromGuards.OrdersGuard,
      NgxPermissionsGuard,
    ],
  },
];

@NgModule({
  imports: [
    SharedModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule,
    MatExpansionModule,
    NgxPaginationModule,
    PdfViewerModule,
    RouterModule.forChild(orderRoutes),
    StoreModule.forFeature('orders', ordersReducers),
    EffectsModule.forFeature(effects),
    ...fromComponents.standaloneComponents,
  ],
  declarations: [...fromComponents.components],
  providers: [],
  exports: [
    ...fromComponents.standaloneComponents,
    ...fromComponents.components,
  ],
})
export class OrdersModule {}
